import Vue from 'vue'
import Router from 'vue-router'
import store from './store/'

import Index from './views/Index.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: { auth: 'all' }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
      meta: { auth: false }
    },
    {
      path: '/entities',
      name: 'entities',
      component: () => import(/* webpackChunkName: "about" */ './views/Entities.vue'),
      meta: { auth: true }
    },
    {
      path: '/map',
      name: 'map',
      component: () => import(/* webpackChunkName: "about" */ './views/Map.vue'),
      meta: { auth: true }
    },
    {
      path: '/details/:entity',
      name: 'details',
      props: true,
      component: () => import(/* webpackChunkName: "about" */ './views/Details.vue'),
      meta: { auth: true }
    },
    {
      path: '/photos',
      name: 'photos',
      props: true,
      component: () => import(/* webpackChunkName: "about" */ './views/Photos.vue'),
      meta: { auth: true }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      props: true,
      component: () => import(/* webpackChunkName: "about" */ './views/Dasboard.vue'),
      meta: { auth: 'admin' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const auth = to.meta.auth || false
  if (auth) {
    const user = store.getters.user

    if (!user) {
      store.dispatch('login').then(usr => {
        proceed(usr)
      }).catch(err => {
        console.log(err)
        next({ name: 'login' })
      })
    } else {
      proceed(user, auth)
    }
  } else {
    next()
  }

  function proceed (user, auth) {
    const isAllowed = auth === 'admin' ? user && user.admin : user
    if (isAllowed) next()
    else next({ name: 'login' })
  }
})

export default router
